import React, { useEffect, useState } from 'react';
import { ShowData, ShowContextProvider, useShowContext } from 'framework/show';
import { getFileTypeFromName } from 'domain/shared/artifact';
import type { AcceptanceDocumentSearchResultItem } from '../../../acceptanceTypes';
import { useDocumentStorageContext } from 'framework/documentStorage';
import { ArtifactStorageTypeIcon } from 'domain/shared/artifactStorage';

const IMAGE_TYPE = 'image';
const thumbStyle = { width: 24, height: 24, objectFit: 'contain' as const };

const AcceptanceArtifactStorageTypeIcon = () => {
  const { data } = useShowContext();
  const row = (data?.getData?.() ?? {}) as AcceptanceDocumentSearchResultItem;
  const path = row?.path ?? '';
  const fileName = (row?.metadata?.fileName as string) ?? path;
  const type = getFileTypeFromName(fileName);
  const { getDocumentToken } = useDocumentStorageContext();

  const [imageUrl, setImageUrl] = useState<string | null>(null);

  useEffect(() => {
    if (type !== IMAGE_TYPE || !path) {
      setImageUrl(null);
      return;
    }
    getDocumentToken(path).then(url => {
      if (url) setImageUrl(url);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, path]);

  if (type === IMAGE_TYPE && imageUrl) {
    return <img src={imageUrl} alt="" title={type} style={thumbStyle} />;
  }

  const rowData = {
    type,
    file: {
      artifact: {
        id: row?.id ?? path,
        type,
        title: fileName || path || 'Document',
      },
    },
  };

  return (
    <ShowContextProvider value={{ data: new ShowData(rowData) }}>
      <ArtifactStorageTypeIcon label="" source="type" width={45} />
    </ShowContextProvider>
  );
};

export default AcceptanceArtifactStorageTypeIcon;
